"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import LightningCategoryContent from '../components/LightningCategoryContent';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import banner1 from '../images/lightningcategory/lightning-category-banner.jpg';
import banner_360 from '../images/lightningcategory/lightning-category-banner_360.jpg';
import banner_tab from '../images/lightningcategory/lightning-category-banner_tab.jpg';
import banner1_2x from  '../images/lightningcategory/lightning-category-banner@2x.jpg';

const LightningCategoryPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok lightning protection system — air terminal and down conductor on a building" bannertext="" ban1x={banner1} ban2x={banner1_2x} ban360={banner_360} bantab={banner_tab}/>
           <ProductsubMenu/>
          
          <LightningCategoryContent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default LightningCategoryPage
 
